import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { ReservationContactDto } from '../../../shared/modules/contacts/dtos/reservation-contact.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingItemDto } from '../../../shared/modules/pricing-items/dtos/pricing-item.dto';

/**
 * Create asset reservation DTO
 */
export class CreateAssetReservationDto {
	color?: string;
	uuid!: string;
	notes?: string;
	@TransformDate()
	startsAt!: Date;
	@TransformDate()
	endsAt!: Date;
	assetUuid!: string;
	agentUuid?: string;
	pickupLocationUuid?: string;
	dropOffLocationUuid?: string;
	@TransformInt()
	drivers?: number[];
	pricingItems?: PricingItemDto[];
	reservationContact?: ReservationContactDto;
	@TransformInt()
	accountId?: number;
	files?: FileDto[];
}
